import React from 'react';
import { List } from '@mui/material';
import { PatientActivitiesFilters, PatientActivity } from '@uplift/api';
import { Loader, useOnScreenObserver } from '@uplift/ui-v2';
import { SidebarActivityItem } from './SidebarActivityItem.component';
import { usePatientActivityQuery } from '@uplift/queries';

export type SidebarActivityItemsPageProps = {
  items: PatientActivity[];
  selectedItem?: PatientActivity;
  onSelectItem: (item: PatientActivity | null) => void;
};

const SidebarActivityItemsPage: React.VFC<SidebarActivityItemsPageProps> = ({ items, selectedItem, onSelectItem }) => (
  <>
    {items.map(item => (
      <SidebarActivityItem
        key={item.datetime}
        activityItem={item}
        selected={item.datetime === selectedItem?.datetime}
        onSelectItem={() => onSelectItem(item)}
      />
    ))}
  </>
);

export type SidebarActivityListProps = {
  patientId: string;
  selectedItem?: PatientActivity;
  onSelectItem: (item: PatientActivity | null) => void;
  filters?: Partial<PatientActivitiesFilters>;
};

export const SidebarActivityList: React.FC<SidebarActivityListProps> = (props) => {
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage } = usePatientActivityQuery(props.patientId, props.filters ?? {});

  const screenObserverRef = useOnScreenObserver(() => {
    if (!isFetchingNextPage) {
      fetchNextPage();
    }
  });

  return (
    <List disablePadding>
      {data?.pages?.map((page) => (
        <SidebarActivityItemsPage
          key={page.cursor}
          items={page.data}
          selectedItem={props.selectedItem}
          onSelectItem={props.onSelectItem}
        />
      ))}
      {hasNextPage && (
        <div ref={screenObserverRef}>
          <Loader color="secondary" size="2rem" my={2} />
        </div>
      )}
    </List>
  );
};
